import { createGlobalStyle } from 'styled-components';

export const DevelopmentStyles = createGlobalStyle`
    @font-face {
        font-family: 'Orgon';
        font-weight: 300;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-LigWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-RegWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 700;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-BolWeb.woff');
    }

    * {
        box-sizing: border-box;
    }

    #pnlHappyEyesCheck {
        height: 100%;
    }

    html,
    body {
        font-family: 'Orgon', Arial, Helvetica, sans-serif;
        height: 100%;
        margin: 0;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    li {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }
`;
